import React, { useState, useEffect, useRef } from "react";
import IconButton from "@mui/material/IconButton";
import { FaCheck } from "react-icons/fa";
import { IoCloseCircle } from "react-icons/io5";
import SFTooltip from "./SFTooltip";


const SFVectorInput = ({ value, onUpdate, precision, disabled, canBeNegative = true, type, removeActions, step=1 }) => {

    const ignoreBlurRef = useRef(false);

    const [prevInputValue, setPrevInputValue] = useState("");
    const [inputValue, setInputValue] = useState("");
    const [isEdited, setIsEdited] = useState(false);

    useEffect(() => {
        let formatted = value ?? "";

        if (value !== null && value !== undefined && value !== "") {
            formatted =
                precision === 0
                    ? String(parseInt(value, 10))
                    : parseFloat(value).toFixed(precision); // STRING
        }
        console.debug("formatted>>??", formatted, value, precision)
        setPrevInputValue(formatted);
        setInputValue(formatted);
        setIsEdited(false);
    }, [value, precision]);

    const commit = () => {
        if (!isEdited || inputValue === "") return;
        let val =
            precision === 0
                ? parseInt(inputValue, 10)
                : parseFloat(inputValue).toFixed(precision);

        setInputValue(val);
        onUpdate(val);
        setIsEdited(false);
    };

    const reset = () => {
        setInputValue(prevInputValue)
        setIsEdited(false);
    }

    const handleChange = (e) => {
        let val = e.target.value;
        if (val === "") {
            setInputValue("");
            setIsEdited(true);
            return;
        }

        val =
            precision === 0
                ? parseInt(val, 10)
                : Number(parseFloat(val).toFixed(precision));

        if (!canBeNegative && val < 0) {
            val = 0;
        }

        setInputValue(val);
        setIsEdited(val !== inputValue);
    }

    const handleKeyDown = (e) => {
        if (!canBeNegative) {
            if (e.key === "-" || e.key === "e") {
                e.preventDefault();
            }
        }
        if (e.key === "Enter") commit();
    }

    const handleBlur = () => {
        if (ignoreBlurRef.current) {
            ignoreBlurRef.current = false;
            return;
        }
        commit();
    }

    let className = "vector-inputs mb-1";
    if (isEdited) {
        className +=  " vector-input-edited mb-1"
    }
    

    return (
        <div style={{ position: "relative", display: "inline-block" }}>
            {canBeNegative ?
                <input
                    disabled={disabled}
                    type="number"
                    className={className}
                    value={inputValue}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    step={step}
                />
                :
                <input
                    disabled={disabled}
                    type="number"
                    className={className}
                    value={inputValue}
                    min={0}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    step={step}
                />
            }

            {removeActions ? null :
            <React.Fragment>
                <IconButton
                    size="small"
                    color="success"
                    aria-label="Save"
                    onMouseDown={() => (ignoreBlurRef.current = true)}
                    onClick={commit}
                    disabled={!isEdited}
                    style={{
                        visibility: isEdited ? "visible" : "hidden"
                    }}
                >
                    <SFTooltip text="Update">
                        <span>
                            <FaCheck size={14} />
                        </span>
                    </SFTooltip>
                </IconButton>
                <IconButton
                    size="small"
                    color="error"
                    aria-label="Cancel"
                    onClick={reset}
                    onMouseDown={() => (ignoreBlurRef.current = true)}
                    disabled={!isEdited}
                    style={{
                        visibility: isEdited ? "visible" : "hidden"
                    }}
                >
                    <SFTooltip text="Cancel">
                        <span>
                            <IoCloseCircle size={18} />
                        </span>
                    </SFTooltip>
                </IconButton>
            </React.Fragment>}
        </div>
    );
};

export default SFVectorInput;
